/* V2
 Horizontal Rows of Template with Remove and Auto-Add functionality
 */
import * as React from "react"
import * as _ from "lodash"
import { QuestionType } from "../utils/AppConstants";
import IStaticDataValue from "../../../common/models/IStaticDataValue";
import AppUtils from "../utils/AppUtils";
import LocalStorageUtils from "../utils/LocalStorageUtils";
import { SectionContext } from "../utils/EventTrackerConstants";

export interface IToggleBtn {
    displayValue: any,
    internalValue: any
}
interface ToggleButtonListProps {
    widgetName?: string
    listItems: IStaticDataValue[],
    selectedItems: string[],
    onSelectionChange: (selectedItems: any[] | string | boolean, additionalArgs?: any, internal?: boolean) => void,
    additionalOnChangeArgs?: any
    selectableText?: string;
    type?: QuestionType;
    keyName?: string;
    isViewOnly?: boolean;
    handleTagsClick?: (event: any, tagValue: string) => void;
    preventClickEvent?: boolean // TODO: temp flag. remove it
    buttonClassName?: string;
}
interface ToggleButtonListStates {
    selectAll: boolean
}

class ToggleButtonList extends React.Component<ToggleButtonListProps, ToggleButtonListStates> {

    constructor(props: ToggleButtonListProps) {
        super(props);
        this.state = { selectAll: false };
    }

    static contextType = SectionContext;
    // Use value parameter for values other then string
    handleItemChange = (event: any, value: any) => {
        if (this.props.handleTagsClick) {
            this.props.handleTagsClick(event, value)
        }
        if (this.props.keyName && !this.props.preventClickEvent) {
            LocalStorageUtils.setClickEvents({ value: value, field: this.props.keyName, widget: this.props.widgetName || this.props.keyName, section: this.context })
        }
        let selectedValue = event ? event.target.dataset.value : value;
        let selectedItemsList: any = !AppUtils.isDefined(this.props.selectedItems) ? [] : this.props.selectedItems;
        if (this.props.type === QuestionType.BOOLEAN_TOGGLE) {
            if (selectedItemsList.indexOf(value) !== -1) {
                this.props.onSelectionChange(null, this.props.keyName);
            } else {
                this.props.onSelectionChange(value, this.props.keyName);
            }
        } else {
            if (selectedItemsList && selectedItemsList.indexOf(selectedValue) !== -1) {
                let updatedSelectedValues = selectedItemsList;
                updatedSelectedValues.splice(selectedItemsList.indexOf(selectedValue), 1);
                if (!_.isEmpty(this.props.additionalOnChangeArgs))
                    this.props.onSelectionChange(updatedSelectedValues, this.props.additionalOnChangeArgs);
                else
                    this.props.onSelectionChange(updatedSelectedValues, this.props.keyName);
            } else {
                let updatedSelectedValues = [...selectedItemsList, selectedValue]
                if (!_.isEmpty(this.props.additionalOnChangeArgs))
                    this.props.onSelectionChange(updatedSelectedValues, this.props.additionalOnChangeArgs);
                else
                    this.props.onSelectionChange(updatedSelectedValues, this.props.keyName);
            }
        }
    }

    toggleSelectAll = () => {
        if (this.state.selectAll) {
            this.props.onSelectionChange([], this.props.keyName);
            LocalStorageUtils.setClickEvents({ value: "SELECT_ALL", field: this.props.keyName, widget: this.props.widgetName, section: this.context })
        } else {
            let updatedSelectedValues = this.props.listItems.map((item, index) => {
                return item.internalValue;
            })
            LocalStorageUtils.setClickEvents({ value: updatedSelectedValues, field: this.props.keyName, widget: this.props.widgetName, section: this.context })
            this.props.onSelectionChange(updatedSelectedValues, this.props.keyName);
        }
        this.setState({ selectAll: !this.state.selectAll });
    }

    render() {
        let myInstance = this;
        let currListItems = Object.assign([], this.props.listItems);
        let selectedItems = this.props.selectedItems;
        let showSelectAll = this.props.type === QuestionType.SELECTABLE_TOGGLE_LIST;
        let selectAllCls = showSelectAll && this.state.selectAll ? "active" : "";
        let buttonCss: React.CSSProperties = this.props.buttonClassName === "opaque" ? { opacity: 1 } : {};
        return (
            <div>
                <div className="toggle-button-items">
                    {showSelectAll && this.props.selectableText && <input type="button" className={`toggleButton ${selectAllCls}`}
                        value={this.props.selectableText} data-value={this.props.selectableText}
                        onClick={(e) => myInstance.toggleSelectAll()} />}
                    {
                        _.map(currListItems, function (listItem, index) {
                            let cssClass = selectedItems && selectedItems.indexOf(listItem.internalValue) !== -1 ? "active" : "";
                            return <input type="button" className={`toggleButton ${cssClass}`} key={`item-${index}`}
                                value={listItem.displayValue} data-value={listItem.internalValue}
                                onClick={(e) => myInstance.handleItemChange(e, listItem.internalValue)}
                                disabled={myInstance.props.isViewOnly} style={buttonCss}/>
                        })
                    }
                </div>
            </div>
        );
    }
}

export default ToggleButtonList